module.exports = __webpack_public_path__ + "static/media/teenages_youth.e368fcae.png";